import { render, staticRenderFns } from "./CABResultStatis.vue?vue&type=template&id=6fea7034&scoped=true&"
import script from "./CABResultStatis.vue?vue&type=script&lang=js&"
export * from "./CABResultStatis.vue?vue&type=script&lang=js&"
import style0 from "./CABResultStatis.vue?vue&type=style&index=0&id=6fea7034&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fea7034",
  null
  
)

export default component.exports